export class ParseHelperUtils {

  static parseToTextHtml(value: string): string | null | undefined {
    const parser = new DOMParser();
    const document = parser.parseFromString(value, 'text/html');

    return document.body.firstChild?.textContent;
  }
}